import Component from '@glimmer/component';

import { uniqueId } from '@ember/helper';
import element_ from 'ember-element-helper/helpers/element';

import or from 'rise-ui/helpers/or.js';

export default class UniqueIdElComponent extends Component {
  <template>
    {{#let
      (uniqueId)
      (element_ (or @tag "span"))
      as | id Tag |
    }}
    <Tag ...attributes>{{yield id}}</Tag>
    {{/let}}
  </template>
}
